import CssVariables from '../theme/variables/CssVariables.js';
var ANALYTICS_DEFAULT_COLORS = [CssVariables['--up-blue-50'], CssVariables['--up-light-blue-50'], CssVariables['--up-orange-30'], CssVariables['--up-green-30'], CssVariables['--up-light-pink-50'], CssVariables['--up-blue-30'], CssVariables['--up-bright-pink-60'], CssVariables['--up-yellow-35'], CssVariables['--up-purple-50'], CssVariables['--up-teal-50']];
var ANALYTICS_SANKEY_COLORS = [CssVariables['--up-blue-50'], CssVariables['--up-green-40'], CssVariables['--up-yellow-40'], CssVariables['--up-orange-40'], CssVariables['--up-blue-35'], CssVariables['--up-blue-30'], CssVariables['--up-blue-10'], CssVariables['--up-bright-red-50']];
var DEFAULT_SUFFIX_META = [{
  base: 1000,
  suffix: 'K'
}, {
  base: 1000000,
  suffix: 'M'
}, {
  base: 1000000000,
  suffix: 'B'
}, {
  base: 1000000000000,
  suffix: 'T'
}];
var CURRENCY_LOCALE_MAPPING = {
  INR: {
    languageCode: 'en-IN',
    suffixMeta: [{
      base: 1000,
      suffix: 'K'
    }, {
      base: 100000,
      suffix: 'L'
    }, {
      base: 10000000,
      suffix: 'Cr'
    }, {
      base: 1000000000,
      suffix: 'B'
    }]
  },
  USD: {
    languageCode: 'en-US',
    suffixMeta: DEFAULT_SUFFIX_META
  },
  AED: {
    languageCode: 'ar-AE',
    suffixMeta: DEFAULT_SUFFIX_META
  },
  IDR: {
    languageCode: 'en-US',
    suffixMeta: DEFAULT_SUFFIX_META
  }
};
var ChartType;
(function (ChartType) {
  ChartType["PIE"] = "pie";
  ChartType["LINE"] = "line";
  ChartType["SANKEY"] = "sankey";
})(ChartType || (ChartType = {}));
export { ANALYTICS_DEFAULT_COLORS, ANALYTICS_SANKEY_COLORS, CURRENCY_LOCALE_MAPPING, ChartType, DEFAULT_SUFFIX_META };
//# sourceMappingURL=chart.config.js.map
